export const comments_3899727 = {"data":{"data":[],"links":{}}}